








import { notifyError, notifySuccess } from "@/common/notify";
import { getSSOToken } from "@/services";
import store, { AuthModule } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SSO extends Vue {
  // Static flag to prevent multiple executions
  // This is used to ensure that the SSO login process is only executed once
  // even if the component is mounted multiple times (e.g., due to route changes)
  static isFirstExecution = true;

  mounted() {
    if (!SSO.isFirstExecution) return;
    SSO.isFirstExecution = false;

    this.onViewMount();
  }

  async onViewMount() {
    // Wait 1 second before running the logic
    await new Promise(resolve => setTimeout(resolve, 1000));

    if (store.state.auth.token) {
      // Clear the existing token and state (logout) before proceeding with SSO login
      AuthModule.store.resetAuthState();
    }

    const SSOToken = this.$route.query.token;

    if (!SSOToken) {
      if (store.state.auth.token) {
        return this.$router.replace({ name: "dashboard" });
      }
      return this.$router.replace({ name: "login" });
    }

    try {
      const response = await getSSOToken(SSOToken as string);

      await AuthModule.store.loginSSO(response);
      notifySuccess("Login effettuato con successo");

      const path = (this.$route.query.r as string) || "/dashboard";
      this.$router.replace({ path });
    } catch (error) {
      notifyError("Si è verificato un errore durante il tentativo di autenticazione con SSO. Riprova più tardi.");

      AuthModule.store.resetAuthState();

      if (store.state.auth.token) {
        return this.$router.replace({ name: "dashboard" });
      }
      return this.$router.replace({ name: "login" });
    }
  }
}
